import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common'

/*
  Generated class for the PostProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class TBRProvider {
  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) {}

  private _url: string = this.commonProvider.apiUrl + 'api/v1/tbr';

  getPersonality(user_id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._url + '/personality/get', {user_id});
  }

  getQuestions(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._url + '/question/get');
  }

  saveQuestions(answers): Observable<Response<any>> {
        return this.http.post<Response<any>>(this._url + `/question/saveanswer`, answers);
  }

}




// WEBPACK FOOTER //
// ./src/providers/tbr/tbr.ts